import React from "react";
import styled, { css } from "styled-components";
import { Content } from "../Content";
import { GradientBox } from "../GradientBox";
import { mobileQuery } from "../MediaQuery";
import { Navigation } from "../navigation/Navigation";
import { ResponsiveLayout } from "../ResponsiveLayout";
import { SizedBox } from "../SizedBox";
import { ScreenshotSlides } from "./ScreenshotSlides";

const HeaderDefaultCore: React.FC = () => {
  return (
    <ResponsiveLayout justifyContent="space-around">
      <GallerySection />

      <PromoSection>
        <SizedBox desktopHeight={100} mobileHeight={40} />

        <TextHuge>Acquire</TextHuge>

        <TextHuge right>Connect</TextHuge>

        <TextHuge>Engage</TextHuge>

        <TextHuge right>Increase</TextHuge>
        <TextHuge right>health-span</TextHuge>
        <TextLarge right>of your policyholders</TextLarge>

        <SizedBox desktopHeight={16} mobileHeight={42} />
      </PromoSection>
    </ResponsiveLayout>
  );
};

export const Header: React.FC = () => {
  return (
    <header>
      <GradientBox>
        <Navigation />
        <Content>
          <HeaderDefaultCore />
        </Content>
      </GradientBox>

      <SizedBox height={46} />
    </header>
  );
};

const GallerySection = styled(ScreenshotSlides)`
  order: 0;
  margin: 60px 24px -50px 0;
  ${mobileQuery`
    order: 1;
    margin: 0 0 -50px 0;
  `}
`;

const PromoSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 680px;
  order: 1;

  ${mobileQuery`
    width: inherit;
    order: 0;
  `}
`;

const baseStyles = css`
  margin: 0;
  white-space: pre-wrap;
  font-family: "Work Sans", sans-serif;
`;

const TextHuge = styled.h2<{ right?: boolean }>`
  ${baseStyles};
  font-size: 80px;
  font-weight: 700;
  color: white;
  ${(props) => props.right && "text-align: right"};
  ${mobileQuery`
    font-size: 40px;
  `}
`;

const TextLarge = styled.h2<{ right?: boolean }>`
  ${baseStyles};
  font-size: 48px;
  font-weight: 500;
  color: white;
  ${(props) => props.right && "text-align: right"};
  ${mobileQuery`
    font-size: 24px;
  `}
`;
